import React from 'react';
import { programs } from '../../data/programs';
import { site, socials } from '../../data/site';
import { usePrograms } from '../../contexts/ProgramContext';
import { Container } from '../ui/Container';
import { SocialIcon } from '../ui/SocialIcon';
const headingClass = 'text-sm font-semibold uppercase tracking-[0.12em] text-white/55';
const linkClass = 'inline-flex min-h-[40px] items-center text-[15px] text-white/80 transition-colors duration-150 hover:text-white';
export function Footer() {
  const {
    setActiveId
  } = usePrograms();
  const year = new Date().getFullYear();
  return <footer className="on-dark bg-black text-white" data-id="element-251" data-mp="3n32hvlxzgvoa">
      <Container className="grid gap-12 py-16 sm:grid-cols-2 lg:grid-cols-12 lg:gap-8" data-id="element-252" data-mp="3n1hlrrw0t4ob">
        <div className="sm:col-span-2 lg:col-span-4" data-id="element-253" data-mp="3j3tnqfz16vs7">
          <a href="#top" className="inline-flex items-center gap-4" data-id="element-254" data-mp="3e3fcyq61p7qh">
            <img src={site.logo} alt="" className="h-24 w-auto" loading="lazy" data-id="element-255" data-mp="3e4qgqpzhqfhl" />
            <span className="font-display text-[1.75rem] font-bold uppercase leading-[0.95] tracking-wide" data-id="element-256" data-mp="394ktrn461h5u">
              Bates
              <br data-id="element-257" data-mp="2p3tgsg55qrem" />
              Taekwondo
            </span>
          </a>
          <p className="mt-5 max-w-[22rem] text-[15px] leading-relaxed text-white/70" data-id="element-258" data-mp="2p5xt9mh4gyqi">
            Family-owned and operated since 2015. Olympic-style Taekwondo for ages 3 through adult in Albuquerque.
          </p>
        </div>

        <div className="lg:col-span-3" data-id="element-259" data-mp="341dgp8n75wdx">
          <h2 className={headingClass} data-id="element-260" data-mp="342ezjzagfn67">Visit &amp; contact</h2>
          <address className="mt-4 not-italic text-[15px] leading-relaxed text-white/80" data-id="element-261" data-mp="3837dh5u9ug8t">
            {site.street}
            <br data-id="element-262" data-mp="2u1uwcr3dk8lc" />
            {site.cityLine}
          </address>
          <ul className="mt-2" data-id="element-263" data-mp="2z20rwicrmf8p">
            <li data-id="element-264" data-mp="2z0y2yfz06mvf">
              <a href={site.directionsUrl} target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-265" data-mp="2z0pssvu9lvnx">
                Get directions<span className="sr-only" data-id="element-266" data-mp="1ipu3p13e400b"> (opens in a new tab)</span>
              </a>
            </li>
            <li data-id="element-267" data-mp="1nkras2h3zzak">
              <a href={site.phoneHref} className={linkClass} data-id="element-268" data-mp="13kpxzpdf483v">
                {site.phoneDisplay}
              </a>
            </li>
            <li data-id="element-269" data-mp="ziw4q25jy6dq">
              <a href={site.emailHref} className={linkClass} data-id="element-270" data-mp="zkfm5w2y2nh3">
                {site.email}
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-2" data-id="element-271" data-mp="ptkv8eer6zpb">
          <h2 className={headingClass} data-id="element-272" data-mp="psjlqeddyl9p">Programs</h2>
          <ul className="mt-3" data-id="element-273" data-mp="ku8aq0bcu4pw">
            {programs.map(p => <li key={p.id} data-id="element-274" data-mp="kvjalp1oisbq">
                <a href="#program-detail" onClick={() => setActiveId(p.id)} className={linkClass} data-id="element-275" data-mp="fveva2cic3n3">
                  {p.name}
                </a>
              </li>)}
            <li data-id="element-276" data-mp="bvnztlc1czc8">
              <a href="#first-class" className={linkClass} data-id="element-277" data-mp="6ugs1m9w805k">
                Free trial class
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-3" data-id="element-278" data-mp="2672pk251qyrz">
          <h2 className={headingClass} data-id="element-279" data-mp="218hwqns4jhdk">Follow Bates</h2>
          <ul className="mt-3" data-id="element-280" data-mp="21916vibj91h1">
            {socials.map(s => <li key={s.name} data-id="element-281" data-mp="28ssl2wkrompm">
                <a href={s.href} target="_blank" rel="noopener noreferrer" className={`${linkClass} gap-3`} data-id="element-282" data-mp="28rhfcr7rh4vv">
                  <SocialIcon name={s.name} className="h-[18px] w-[18px]" data-id="element-283" data-mp="2dp94xekxoeww" />
                  {s.label}
                  <span className="sr-only" data-id="element-284" data-mp="2ijwyvsypi1iv"> (opens in a new tab)</span>
                </a>
              </li>)}
          </ul>
        </div>
      </Container>
      <div className="border-t border-white/10" data-id="element-285" data-mp="1pug9z5aap2re">
        <Container className="flex flex-col gap-2 py-6 text-sm text-white/55 sm:flex-row sm:justify-between" data-id="element-286" data-mp="1us81vzaxwovl">
          <p data-id="element-287" data-mp="1zrkl8a2lrdtf">© {year} Bates Taekwondo. All rights reserved.</p>
          <p data-id="element-288" data-mp="1zq18uuk2hmwx">
            {site.street}, {site.cityLine}
          </p>
        </Container>
      </div>
    </footer>;
}